import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { SourcesMenuButton } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuButton.js';
import { SourcesMenuContent } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuContent.js';
import { SourcesMenuFooter } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuFooter.js';
import { SOURCES_MENU_MIN_WIDTH_PX } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/consts.js';
import { useSuggestedSources } from '#pplx/frontend/apps/ask/sources/hooks/useSuggestedSources.js';
import { memo, useCallback, useMemo } from 'react';
export const SourcesMenu = memo(function SourcesMenu({ isOpen, sources, tooltip, size = 'default', disabled = false, onChange, onSourceMentionSelect, onSourceMentionDeselect, onOpen, onClose, triggerElement, omittedSources, omitCometMcpSources = false, isComputer = false, }) {
    const { suggested: suggestedSources, refresh: refreshSuggestedSources } = useSuggestedSources({
        omittedSources,
        productSurface: isComputer ? 'computer' : 'ask',
    });
    const onToggle = useCallback((isOpen) => {
        if (isOpen) {
            refreshSuggestedSources();
            onOpen?.();
        }
        else {
            onClose?.();
        }
    }, [onOpen, onClose, refreshSuggestedSources]);
    const element = useMemo(() => {
        return (triggerElement ?? (_jsx(SourcesMenuButton, { sources: sources, size: size, disabled: disabled, tooltip: tooltip })));
    }, [triggerElement, sources, size, disabled, tooltip]);
    return (_jsxs(DropdownMenu, { isOpen: isOpen, onToggle: onToggle, align: "end", minWidthPx: SOURCES_MENU_MIN_WIDTH_PX, triggerElement: element, 
        // magic number so the last menu item is cut off to make it more obvious you can scroll
        maxHeightPx: 310, children: [_jsx(SourcesMenuContent, { sources: sources, onChange: onChange, onSourceMentionSelect: onSourceMentionSelect, onSourceMentionDeselect: onSourceMentionDeselect, suggestedSources: suggestedSources, omittedSources: omittedSources, omitCometMcpSources: omitCometMcpSources, isComputer: isComputer }), _jsx(SourcesMenuFooter, {})] }));
});
//# sourceMappingURL=SourcesMenu.js.map